import { FormModel } from 'submodules/nerit-framework-ui/common/form-state-manager/types/FormModel'
import { IsOptional } from 'class-validator'

export class ParameterNoteFormModel extends FormModel {

    @IsOptional()
    note?: string

    constructor(initialData?: Partial<ParameterNoteFormModel>) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
